(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('WidgetAcumuladoChuvaCtrl', WidgetAcumuladoChuvaController);

  WidgetAcumuladoChuvaController.$inject = [
    '$scope',
    'DadosMeteorologicosService',
    'googleChartApiPromise',
    'Dashboard'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function WidgetAcumuladoChuvaController($scope, DadosMeteorologicosService, googleChartApiPromise, Dashboard) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.error = false;
    vm.empty = false;
    vm.loading = true;
    vm.chart = {
      type: 'PieChart'
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.validChart = validChart;

    //////////////////////////////////////////
    // Function declarations

    function validChart() {
      const { widget: { dataModelOptions } } = $scope;

      return (dataModelOptions.dataInicial && dataModelOptions.dataFinal) ||
        !(dataModelOptions.dataInicial && dataModelOptions.dataFinal);
    }

    function renderChart() {
      vm.empty = false;
      vm.error = false;
      vm.chart = {
        type: 'PieChart'
      };
      vm.loading = true;
      const propriedade = $scope.widget.dataModelOptions.propriedade || $scope.$root.currentPropriedade;

      const request = DadosMeteorologicosService.list({
        data_inicial: $scope.widget.dataModelOptions.dataInicial || moment().subtract(30, 'days')
          .toDate(),
        data_final: $scope.widget.dataModelOptions.dataFinal || new Date(),
        propriedade: propriedade.id
      });

      return request.then(({ data }) => prepareChart(data));
    }

    function prepareChart(result) {
      if (result.length) {
        const array = [['Pluviômetro', 'Milímetros']];
        const reduced = result.reduce((group, data) => {
          if (group[data.descricao]) {
            group[data.descricao] += data.chuva;
          } else {
            group[data.descricao] = data.chuva;
          }
          return group;
        }, {});

        Object.entries(reduced).forEach((entry) => array.push(entry));
        createChart(array);
      } else {
        vm.loading = false;
        vm.empty = true;
      }
    }

    function createChart(array) {
      return googleChartApiPromise.then(() => {
        const dataTable = google.visualization.arrayToDataTable(array);

        vm.chart = chartOptions();
        vm.chart.data = dataTable;

        vm.loading = false;
      });
    }

    function chartOptions() {
      return {
        type: 'PieChart',
        data: {
          cols: [],
          rows: []
        },
        options: {
          title: '',
          subtitle: '',
          legend: { position: 'right' },
          vAxis: {
            title: 'Milímetros'
          },
          chartArea: {
            width: '90%',
            height: '90%',
            left: 80
          },
          pieSliceText: 'value'
        }
      };
    }

    function calcChartWidth() {
      return Dashboard.calcChartWidth($scope.widget.size.width);
    }

    //////////////////////////////////////////
    // Controller logic

    // eslint-disable-next-line max-lines-per-function
    $scope.$root.initialize.then(() => {
      $scope.widget.data = {
        propriedades: $scope.$root.propriedades.map((propriedade) => ({
          id: propriedade.id,
          descricao: propriedade.descricao
        }))
      };

      if ($scope.widget.dataModelOptions.intervalShortcut) {
        const today = moment();
        $scope.widget.dataModelOptions.dataInicial = today
          .clone()
          .subtract($scope.widget.dataModelOptions.intervalShortcut, 'days')
          .toDate();
        $scope.widget.dataModelOptions.dataFinal = today.toDate();
      }

      if (typeof $scope.widget.dataModelOptions.dataInicial === 'string') {
        $scope.widget.dataModelOptions.dataInicial = moment($scope.widget.dataModelOptions.dataInicial).toDate();
      }
      if (typeof $scope.widget.dataModelOptions.dataFinal === 'string') {
        $scope.widget.dataModelOptions.dataFinal = moment($scope.widget.dataModelOptions.dataFinal).toDate();
      }

      $scope.$watch('widget.dataModelOptions', () => {
        if (vm.validChart()) {
          const render = renderChart();
          render.catch((error) => {
            vm.error = true;
            console.error('Erro ao renderizar gráfico', error);
          });
        }
      }, true);
      $scope.$watch('widget.size.width', () => {
        if ((vm.chart || {}).options) {
          vm.chart.options.width = `${calcChartWidth() }px`;
        }
      });
    })
      .catch($scope.$root.errorRootInitialize);
  }
}());
